import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { kpiApi } from '@/lib/kpis';
import { KpiTile } from './KpiTile';

/**
 * Dashboard KPI strip — one batched call computes every enabled KPI. Renders
 * nothing when there are no KPIs (so the dashboard is unchanged until a user
 * defines one). Plan-gated server-side: Free tier returns [].
 */
export function KpiTiles({ wsId }: { wsId: string }) {
  const { t } = useTranslation();
  const { data = [] } = useQuery({ queryKey: ['kpi-dashboard', wsId], queryFn: () => kpiApi.dashboard(wsId), enabled: !!wsId, retry: false });
  if (data.length === 0) return null;
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-sm font-semibold text-ink-700">{t('kpi.dashboard_title', { defaultValue: 'KPIs' })}</h2>
        <Link to={`/app/workspace/${wsId}/kpis`} className="text-[12px] font-semibold text-emerald-700 hover:text-emerald-800">{t('kpi.manage', { defaultValue: 'Manage KPIs →' })}</Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {data.map((k) => <KpiTile key={k.kpiId ?? k.name} kpi={k} />)}
      </div>
    </div>
  );
}
